<template>
  <div>
    <section class="title_bar">
      <div class="container no-padding">
        <router-link :to="{ name: 'index' }">
          <i class="title_bar-icon kp-panel-back" aria-hidden="true"></i>
        </router-link>
        <h1 class="title_bar-title">
          <i class="kp-panel-report" aria-hidden="true"></i>
          {{ $t('report.menu.report_of') }} “{{ boxName }}”
          <p>
            <router-link class="back-to-resume" v-if="showBackToResume()" :to="{ name: 'boxReportsResume', params: { boxId: $route.params.boxId }}">
              <i class="kp-panel-back" aria-hidden="true"></i>{{ $t('report.menu.back_to_answers_summary') }}
            </router-link>
          </p>
        </h1>

        <ul class="tab_pages">
          <li>
            <router-link :to="{ name: 'boxReportsMetrics', params: { locale: i18n.locale, boxId: $route.params.boxId }}" class="tab_pages-item" active-class="active" exact>
              <i class="kp-panel-metrics" aria-hidden="true"></i>{{ $t('report.menu.metrics') }}
            </router-link>
          </li>
          <!-- <li> -->
          <!--   <router-link :to="{ name: 'boxReportsResume', params: { boxId: $route.params.boxId }}" class="tab_pages-item" active-class="active" exact> -->
          <!--     <i class="kp-panel-resume" aria-hidden="true"></i> Resumo das Respostas -->
          <!--   </router-link> -->
          <!-- </li> -->
          <li>
            <router-link :to="{ name: 'boxReportsIndividuals', params: { locale: i18n.locale, boxId: $route.params.boxId }}" class="tab_pages-item" active-class="active" exact>
              <i class="kp-panel-table" aria-hidden="true"></i>{{ $t('report.menu.individual_answers') }}
            </router-link>
          </li>
          <li class="report-box-options">
            <a class="tab_pages-item">
              <i class="fa fa-ellipsis-h" aria-hidden="true"></i>
            </a>
            <div class="dropdown-menu">
              <ul class="dropdown-menu-container">
                <li class="highlight">{{ $t('report.menu.box_options') }}</li>
                <li>
                  <export-box :box="boxActive"></export-box>
                </li>
                <li class="mobile-hide">
                  <edit-box v-if="boxActive.id" :box="boxActive"></edit-box>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </section>
    <div class="container no-padding">
      <router-view></router-view>
    </div>
    <modal-code></modal-code>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ExportBox from './components/report/ExportBox.vue';
import EditBox from './components/report/EditBox.vue';
import ModalCode from './components/modal/Code.vue';
import i18n from './i18n';

export default {
  data() {
    return {
      i18n,
    };
  },
  created() {
    this.$store.dispatch('boxGet');
  },
  methods: {
    showBackToResume() {
      return this.$route.name === 'boxReportsEmails';
    },
  },
  components: {
    ExportBox,
    EditBox,
    ModalCode,
  },
  computed: mapGetters({
    boxName: 'boxName',
    boxActive: 'boxActive',
  }),
};
</script>

<style>
  section.title_bar {
    margin-top: 90px;
  }

  .report-box-options {
    position: relative;
    cursor: pointer;
  }

  .tab_pages > li.report-box-options:hover .dropdown-menu,
  .tab_pages > li.report-box-options:active .dropdown-menu {
    display: block;
    padding-top: 0;
  }

  .tab_pages > .report-box-options .dropdown-menu {
    font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 14px;
  }

  .report-box-options .dropdown-menu li {
    display: block;
    box-sizing: border-box;
    width: 100%;
  }

  .report-box-options .dropdown-menu li.highlight {
    background: #8097bc;
    color: #fff;
    padding: 20px 22px;
    position: relative;
    text-align: center;
  }

  .report-box-options .dropdown-menu li.highlight::after {
    content: '';
    position: absolute;
    border-style: solid;
    border-width: 0 10px 7px;
    border-color: #8097bc transparent;
    display: block;
    width: 0;
    z-index: 1;
    top: -7px;
    right: 45%;
  }

  .report-box-options .dropdown-menu li a.option {
    display: block!important;
    font-size: 13px;
    color: #677a99;
    background: #fff;
    line-height: 13px;
    text-align: left;
    padding: 21px 22px;
  }

  .report-box-options .dropdown-menu li a:hover {
    background: #f5f5f5;
  }

  .report-box-options .tab_pages-item:hover {
    border-bottom: none;
  }

  @media(max-width: 767px) {
    .dropdown-menu {
      left: -40px;
    }

    .dropdown-menu-container > li {
      max-width: 100%;
    }
  }

  .back-to-resume {
    font-size: 12px;
    color: #d2d2d2;
  }

  .back-to-resume > i {
    font-size: 12px;
  }

</style>



/** WEBPACK FOOTER **
 ** Report.vue?30486d6b
 **/